import React from 'react'
import '../App.css';
import Creador from './Creador';


function Footer(){

    const redireccionar=()=>{
        window.location.href = '/inventario';
    }

    return (
        <>
        <footer>

            <main>
                <div className="principal">
                    <h2>ShaBless</h2>
                </div>

                <div className="secondary">
                    
                    <a href="https://instagram.com/shabless24?igshid=YmMyMTA2M2Y=" target="_blank" class="fab fa-instagram"> Instagram</a>

                    <article className={localStorage.getItem('UrlGoogle') === null?'login-none':''}>
                        <img onClick={()=>redireccionar()} src={localStorage.getItem('UrlGoogle')} className='img-auth' alt="" />
                    </article>
                    
                </div>
            </main>

        </footer>
                
        <footer class="w-full p-4 mb-[-25px] mt-10 bg-[#fb8cff] border-t border-gray-200 shadow md:flex md:items-center md:justify-between md:p-6">
            <span class="text-sm sm:text-center">© 2023 <a href="https://keurylendof.vercel.app/" target='_blank' class="hover:underline">KeuryLendof™</a>. All Rights Reserved.
            </span>
            <ul class="flex flex-wrap items-center mt-3 text-sm font-medium text-black-500 sm:mt-0">
                <li>
                    <a href="#" class="mr-4 hover:underline md:mr-6">About</a>
                </li>
                <li>
                    <a href="#" class="mr-4 hover:underline md:mr-6">Privacy Policy</a>
                </li>
                <li>
                    <a href="#" class="mr-4 hover:underline md:mr-6">Licensing</a>
                </li>
                <li>
                    <a href="#" class="hover:underline">Contact</a>
                </li>
            </ul>
        </footer>

        {/* <Creador/> */}
        </>
    )
}

export default Footer
